import { IxMenuAnchor } from './IxMenuAnchor.js';

window.customElements.define('ix-menu-anchor', IxMenuAnchor);
